export default __webpack_public_path__ + "c47824d795351434c791522c5d07d746.png";